<template>
  <el-dialog
    :visible="detailDialogVisible"
    title="审核详情"
    @open="openDialog"
    @close="closeDialog"
  >
    <el-form label-width="200px" :model="auditDetail">
      <el-form-item label="账号：">
        {{ auditDetail.userId }}
      </el-form-item>
      <el-form-item label="真实姓名：">
        {{ auditDetail.realName }}
      </el-form-item>
      <el-form-item label="证件类型：">
        {{ auditDetail.idType === 1 ? "护照" : "身份证" }}
      </el-form-item>
      <el-form-item label="证件号：">
        {{ auditDetail.cardNo }}
      </el-form-item>
      <el-form-item label="国家：">
        {{
          (
            (countryCodeList &&
              countryCodeList.find(
                (item) => `${item.code}` === auditDetail.country
              )) ||
            {}
          ).zh
        }}
      </el-form-item>
      <el-form-item label="证件照片：">
        <image-wrapper
          :src="auditDetail.idFrontImg"
          :inline="true"
          width="300px"
          height="150px"
        ></image-wrapper>
        <image-wrapper
          :src="auditDetail.idBackImg"
          :inline="true"
          width="300px"
          height="150px"
        ></image-wrapper>
      
      </el-form-item>
      <el-form-item label="脸部照片：" v-if="auditDetail.idFaceImg">
        <image-wrapper
          :src="auditDetail.idFaceImg"
          :inline="true"
          width="300px"
          height="150px"
        ></image-wrapper>
      </el-form-item>
    </el-form>
    <el-input
      v-if="auditDetail.status === 2"
      type="textarea"
      disabled
      :value="auditDetail.backReason"
      class="reason-input"
    ></el-input>
    <span slot="footer" class="dialog-footer">
      <el-button
        @click="toggleDetailDialogVisible(false)"
        v-if="auditDetail.status === 0"
        >取消</el-button
      >
      <el-button
        type="primary"
        @click="approveAudit(true)"
        v-if="auditDetail.status === 0"
        >审核通过</el-button
      >
      <el-button
        type="danger"
        @click="approveAudit(false)"
        v-if="auditDetail.status === 0"
        >审核不通过</el-button
      >
      <el-button
        @click="toggleDetailDialogVisible(false)"
        v-if="auditDetail.status !== 0"
        >关闭</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import ImageWrapper from "components/image";

export default {
  name: "AuditDetail",
  props: ["value", "type"],
  components: {
    ImageWrapper,
  },
  methods: {
    ...mapActions("kycAudit", [
      "detail",
      "details",
      "approve",
      "getCountryCodeList",
    ]),
    ...mapMutations("kycAudit", ["toggleDetailDialogVisible"]),
    openDialog() {
      if (this.type != 1) {
        this.detail(this.value);
      } else {
        this.details(this.value);
      }
    },
    closeDialog() {
      this.toggleDetailDialogVisible(false);
    },
    approveAudit(isPass) {
      const action = isPass
        ? this.$confirm("确认执行此操作吗？", "提示", {
            type: "warning",
          })
        : this.$prompt("请输入审核不通过原因", "提示", {
            inputValidator: (value) => {
              return !value || !value.trim() ? "请输入不通过原因" : true;
            },
          });

      action
        .then(({ value }) => {
          this.approve({
            id: this.value,
            backReason: isPass ? undefined : value,
            status: isPass ? 1 : 2,
          }).then(() => {
            this.$message({
              type: "success",
              message: "操作成功！",
            });
            this.toggleDetailDialogVisible(false);
            this.$emit("onUpdate");
          });
        })
        .catch(() => {});
    },
  },
  mounted() {
    this.getCountryCodeList();
  },
  updated() {
    console.log("this.auditDetail", this.auditDetail);
  },
  computed: {
    ...mapState("kycAudit", [
      "detailDialogVisible",
      "countryCodeList",
      "auditDetail",
    ]),
  },
};
</script>

<style lang="less" scoped>
@import "~styles/variables.less";

.reason-input {
  width: 100%;
  /deep/ .el-textarea__inner {
    border-color: @color-danger;
    background-color: lighten(@color-danger, 25%);
    resize: none;
    color: #333;
  }
}
</style>
